import { render, staticRenderFns } from "./bidBudget.vue?vue&type=template&id=51655da6&scoped=true&"
import script from "./bidBudget.vue?vue&type=script&lang=js&"
export * from "./bidBudget.vue?vue&type=script&lang=js&"
import style0 from "./bidBudget.vue?vue&type=style&index=0&id=51655da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51655da6",
  null
  
)

export default component.exports